/**************
 Collection Item ATC
 ***************/

document.querySelectorAll(".collectionItem").forEach(function (element) {
    element.querySelector(".atc").addEventListener("click", async function () {
        // add loading animation
        this.classList.add("loading");

        let formData = {
            items: [{
                quantity: 1,
                id: parseInt(element.getAttribute("id")),
            }]
        };

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        await openCart();
    });
});